import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=d84eedb4&scoped=true"
import script from "./Indicators.vue?vue&type=script&lang=js"
export * from "./Indicators.vue?vue&type=script&lang=js"
import style0 from "./Indicators.vue?vue&type=style&index=0&id=d84eedb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84eedb4",
  null
  
)

export default component.exports